<!-- <div class="container-fluid">
    <div class="row">
        <div class="col-sm-6">
            <img src="../../assets/images/login_img.png" />
        </div>
        <div class="login-container col-sm-6">
            <h1 class="title">GMS LOGIN</h1>
            <form [formGroup]="loginForm" class="loginForm" (ngSubmit)="onSubmit()">
                <div class="mb-3">
                    <label for="username">username</label>
                    <input type="text" formControlName="username" class="form-control"
                        [ngClass]="{ 'is-invalid': submitted && f.username.errors }" />
                    <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                        <div *ngIf="f.username.errors.required">username is required</div>
                    </div>
                </div>
                <div class="mb-3">
                    <label for="password">Password</label>
                    <input type="password" formControlName="password" class="form-control"
                        [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                    <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                        <div *ngIf="f.password.errors.required">Password is required</div>
                    </div>
                </div>
                <div class="mb-3">
                    <button [disabled]="loading" class="btn w-100">LOGIN</button>
                </div>
            </form>
        </div>
    </div>
</div> -->




<div class="container-fluid">
    <div class="row no-gutter">
        <div class="d-none d-md-flex col-md-4 col-lg-6 bg-image"></div>
        <div class="col-md-8 col-lg-6">
            <div class="login d-flex align-items-center py-5">
                <div class="container">
                    <div class="row">
                        <div class="col-md-9 col-lg-8 mx-auto">
                            <h1 class="title">{{'gms_login' | gmstranslate }}</h1>
                            <form [formGroup]="loginForm" class="loginForm" (ngSubmit)="onSubmit(loginForm.value)">
                                <div class="mb-3">
                                    <label for="username">{{'username' | gmstranslate}} </label>
                                    <input type="text" formControlName="username" class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && formValues.username.errors }" />
                                    <div *ngIf="submitted && formValues.username.errors" class="invalid-feedback">
                                        <div *ngIf="formValues.username.errors.required">
                                            {{'username_is_required' | gmstranslate}}</div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <label for="password">{{'password' | gmstranslate }}</label>
                                    <input type="password" formControlName="password" class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && formValues.password.errors }" />
                                    <div *ngIf="submitted && formValues.password.errors" class="invalid-feedback">
                                        <div *ngIf="formValues.password.errors.required">
                                            {{ 'password_required' | gmstranslate}}</div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <button [disabled]="!loginForm.valid"
                                        class="w-100">{{'LOGIN' | gmstranslate}}</button>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>